import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import { Grid } from "@material-ui/core";
import {
  Title,
  Margin,
  Input,
  Button,
  ErrorMessage,
  Loading,
} from "~/components/elements";
import { schema } from "./validation";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import isMobile from "~/hooks/isMobile";
import { dateMask, formatDate } from "~/utils/tools";
import ReactSVG from "react-svg";
import exclamation from "~/assets/img/icon/exclamation.svg";


import * as S from "./styles";

export default function FormSignUpStep13() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paramObj = {};
    for (const [key, value] of queryParams.entries()) {
      paramObj[key] = value;
    }
  }, [location]);


  const sending = useSelector((state) => state.signUp.sign.sending);
  const errorMessage = useSelector((state) => state.signUp.sign.errorMessage);
  const initialValues = {
    ParticipanteHash: useSelector(
      (state) => state.authentication.auth.user.ParticipanteHash
    ),
    Email: "",
    ConfirmaEmail: "",
    Senha: "",
    ConfirmaSenha: "",
    NomeFilho: "",
    DataNascimentoFilho: "",
  };

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  return (
    <S.FormHolder>
      <Margin mt={6} mb={mobile ? 3 : 4}>
        <Title as="2" level="6" primary>
          <strong>
            Complete os dados do seu bebê
          </strong>
        </Title>
      </Margin>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(SignUpActions.setSignUpData());
            const date = formatDate(values.DataNascimentoFilho);
            const newDate = new Date(date).toISOString().split("T")[0];
            const payloadValues = {
              ...values,
              Url: url,
              Origin: origin,
              DataNascimentoFilho: newDate
            };

            dispatch(SignUpActions.sendSignUpForm(payloadValues));
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <S.GridHolder>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Margin mb={mobile ? 4 : 3}>
                      <Input
                        label="Nome completo"
                        placeholder="Complete o nome do seu bebê"
                        htmlFor="nameFieldFormSignup"
                        name="NomeFilho"
                        value={values.NomeFilho}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errors={touched.NomeFilho && errors.NomeFilho}
                        valid={!errors.NomeFilho}
                        required
                      />
                    </Margin>
                    <Margin mb={mobile ? 4 : 3}>
                      <Input
                        mask={dateMask}
                        label="Data de nascimento"
                        placeholder="00/00/0000"
                        htmlFor="birthFieldFormSignup"
                        name="DataNascimentoFilho"
                        value={values.DataNascimentoFilho}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errors={touched.DataNascimentoFilho && errors.DataNascimentoFilho}
                        valid={!errors.DataNascimentoFilho}
                        required
                      />
                        {!(touched.DataNascimentoFilho && errors.DataNascimentoFilho) && (
                          <S.BirthDateDisclaimer>
                            <ReactSVG src={exclamation}></ReactSVG>
                            Participação permitida para crianças de até 3 anos.
                          </S.BirthDateDisclaimer>
                        )}
                    </Margin>
                  </Grid>
                </Grid>
              </S.GridHolder>
              <S.ButtonsGrid
                container
                justifyContent="space-between"
                direction={mobile ? "column-reverse" : "row"}
              >
                <Margin mb={mobile ? 3 : 0}>
                  <Button
                    className="animation-size"
                    color={
                      !isValid || !dirty || sending
                        ? "disabled"
                        : "primary"
                    }
                    disabled={!isValid || !dirty || sending}
                    type="submit"
                    id="nextButtonFormSignup"
                  >
                    {sending ? <Loading button /> : "AVANÇAR >"}
                  </Button>
                </Margin>
              </S.ButtonsGrid>
              {errorMessage && (
                <Margin mt={mobile ? 3 : 5}>
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                </Margin>
              )}
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
    </S.FormHolder>
  );
}
